import { Page } from "src/components";
import { useModals } from "src/components/Modals";
import { Box, Button, Color, Flex, Icon, Text } from "src/elements";
import { pages } from "src/utils";
import { useNavigation } from "src/utils/navigation";

const features = [
  "Crafting customer experiences starts from storytelling with your product mix",
  "Understanding customer needs and market trends can turn casual browsers into loyal customers",
  "Reap benefits from store diversity with localised assortment and macrospace allocation processes",
  "Strategically list and systematically delist to lower working capital costs",
];

export const PageImagine = () => {
  const { openModal } = useModals();
  const { navigate } = useNavigation();

  return (
    <Page>
      <Box padding="32px">
        <Text variant="h2">Welcome to Omnistream Imagine</Text>
        <Box padding="40px 10px">
          <Text variant="subtitle2" color={Color.primary}>
            We invite you to expand the possibilities of what your business can achieve with our
            smart retail chatbot.
          </Text>
          <br />
          <Text variant="subtitle2" color={Color.primary}>
            Start a conversation about product assortment or macrospace strategy in any category,
            and deep dive into actionable insights seamlessly!
          </Text>
        </Box>
        <Text variant="h2">What would you like to imagine?</Text>

        <Flex padding="40px 10px" gap="30px" justify="center" align="center">
          <Button
            color="greenSmoke"
            width="230px"
            height="100px"
            onClick={() => openModal("ModalImagineShelvesCategory")}
          >
            <Flex column justify="center" gap="10px">
              <Icon name="bays" color={Color.textSecondary} />
              <Text color={Color.primary}>Shelves</Text>
            </Flex>
          </Button>

          <Flex
            width="230px"
            height="100px"
            background={Color.lightGray}
            justify="center"
            align="center"
            borderRadius="3px"
          >
            <Button
              color="greenSmoke"
              width="230px"
              height="100px"
              onClick={() => navigate(pages.imagineMacrospace)}
            >
              <Flex column justify="center" gap="10px">
                <Icon name="macrospace" color={Color.textSecondary} />
                <Text color={Color.primary}>Macrospace</Text>
              </Flex>
            </Button>
          </Flex>

          <Flex
            width="230px"
            height="100px"
            background={Color.lightGray}
            justify="center"
            align="center"
            borderRadius="3px"
          >
            <Button
              color="greenSmoke"
              width="230px"
              height="100px"
              onClick={() => navigate(pages.imagineAssortment)}
            >
              <Flex column justify="center" gap="10px">
                <Icon name="assortment" color={Color.textSecondary} />
                <Text color={Color.primary}>Assortment</Text>
              </Flex>
            </Button>
          </Flex>
        </Flex>

        <Flex justify="around" align="center" gap="20px" margin="0 auto" maxWidth="1000px">
          {features.map((feature, index) => (
            <Box
              padding="16px"
              width="200px"
              height="112px"
              borderRadius="12px"
              background={Color.opacitySkyActive}
            >
              <Text key={index} variant="small1" color={Color.textSecondary}>
                {feature}
              </Text>
            </Box>
          ))}
        </Flex>
      </Box>
    </Page>
  );
};
